export default "__VITE_ASSET__CfVUQvz4__"